var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullscript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-10.000182152 -15.0000668657 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.813.632a1.888 1.888 0 0 0-1.254-.573 16.188 16.188 0 0 0-14.563 6.732A16.235 16.235 0 0 0 5.418.06c-.474.03-.92.234-1.254.573C-.479 5.275-.03 12.734.047 13.462a20.12 20.12 0 0 0 2.724 8.372c2.29 4.008 7.01 9.286 16.56 12.025h1.408c17.565-4.921 19.098-19.036 19.19-20.398.047-.386.65-8.016-4.116-12.83ZM18.062 17.005l-5.231-5.633a1.95 1.95 0 1 0-2.848 2.647l8.063 8.728v6.655C4.675 24.542 3.947 13.74 3.916 13.276v-.109s-.51-5.617 2.508-9.285h.232a12.257 12.257 0 0 1 11.39 7.258v5.834l.016.032Zm18.014-3.869a.202.202 0 0 0 0 .093c0 .48-.743 11.267-14.114 16.142v-6.624l8.063-8.697a1.948 1.948 0 0 0-1.467-3.382 1.949 1.949 0 0 0-1.38.735l-5.17 5.587v-5.819a12.38 12.38 0 0 1 11.39-7.258h.217c2.94 3.575 2.46 9.162 2.46 9.223Z ",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscript);
export default __webpack_public_path__ + "static/media/fullscript.2de680f37913764d9b4f46400043efdc.svg";
export { ForwardRef as ReactComponent };